<template>
    <div class="card card-round shadow dashboard-widget dashboard-widget--schedule">
        <div class="card-header">
            <h6 class="fw-bold mb-0 dashboard-widget__title">
                <span class="dashboard-widget__icon" v-html="sidebarSvg.projectDetails"></span>
                <span>{{ $t('Project Schedule') }}</span>
            </h6>
        </div>
        <div class="card-body p-0">
            <table class="table table-bordered mb-0">
                <tbody>
                    <tr>
                        <td rowspan="2" valign="middle" class="text-center fw-bold"> {{ $t('Contract') }}</td>
                        <td class="text-center fw-bold"> {{$t('Commencement Date')}}</td>
                        <td class="text-center fw-bold">{{$t('Completion Date')}}</td>
                    </tr>
                    <tr>
                        <td class="text-center">{{projectInfo.startDate|| '-'}}</td>
                        <td class="text-center">{{projectInfo.handOverDate || '-'}}</td>
                    </tr>
                    <tr>
                        <td rowspan="2" valign="middle" class="text-center fw-bold">
                            <span class="text-success">{{$t('Actual')}}</span>/<span class="text-danger"> {{$t('Forecast')}}</span>
                        </td>
                        <td class="text-center fw-bold">{{$t('Commencement Date')}}</td>
                        <td class="text-center fw-bold">{{$t('Handover Date')}}</td>
                    </tr>
                    <tr>
                        <td class="text-center"> -</td>
                        <td class="text-center">-</td>
                    </tr>
                </tbody>
                
            </table>
        </div>
    </div>
</template>

<script>
    import { sidebarSvg } from '@/components/deluxe/DeluxeSidebar.vue'
    export default {
    name : 'ProjectDates',
    props : ['projectInfo'],
    data(){
        return {
            sidebarSvg
        }
    }
} 
</script>
